import { createContext } from 'react';

export type InitContextValue = ReturnType<typeof useInitContextValue>;

export const initContext = createContext<InitContextValue>({} as never);

export function useInitContextValue() {
  const [initQueue, setInitQueue] = useState<Promise<any>[]>([Promise.resolve()]);
  const initialed = useMemo(() => !initQueue.length, [initQueue]);

  const pushInit = useCallback<<T>(p: Promise<T>) => Promise<T>>((p) => {
    setInitQueue((prev) => [...prev, p]);
    return p;
  }, []);

  const value = useMemo(
    () => ({
      initialed,
      pushInit,
    }),
    [initialed, pushInit]
  );

  useEffect(() => {
    if (initQueue.length) {
      Promise.all(initQueue).finally(() => {
        setInitQueue((prev) => prev.filter((p) => !initQueue.includes(p)));
      });
    }
  }, [initQueue]);

  return value;
}

export function useInitContext() {
  return useContext(initContext);
}
